export default `
<svg
  aria-hidden="true"
  aria-label="bars"
  width="20"
  height="20"
  viewBox="0 0 20 20"
  fill="none"
>
  <path d="M3.33331 10H16.6666" stroke="currentcolor" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M3.33331 5H16.6666" stroke="currentcolor" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M3.33331 15H16.6666" stroke="currentcolor" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
